export const KENTIK_POLICY_DEFINITIONS = [
  'DEFINE tenancy KentikTenancy as "{{kentikTenancyId}}"',
  'DEFINE group KentikMetadataGroup as "{{kentikUserGroup}}"'
];

const METADATA_POLICY_DEFINITIONS = [
  "TO INSPECT tenancies in tenancy where all {request.permission='TENANCY_INSPECT', request.operation='ListRegionSubscriptions'}",
  'TO READ compartments in tenancy',
  'TO READ virtual-network-family in tenancy',
  'TO READ cluster-family in tenancy',
  'TO INSPECT instance-family in tenancy',
  'TO INSPECT volume-family in tenancy',
  'TO READ virtual-circuits in tenancy',
  'TO READ drg-attachments in tenancy',
  'TO READ remote-peering-connections in tenancy',
  'TO INSPECT log-groups in tenancy',
  'TO INSPECT network-firewall in tenancy',
  'TO INSPECT service-gateways in tenancy'
];

const FLOWS_POLICY_DEFINITIONS = ['TO READ object-family in tenancy'];
const METRICS_POLICY_DEFINITIONS = ['TO read metrics IN tenancy'];

const ADMIT_PREFIX = 'ADMIT group KentikMetadataGroup of tenancy KentikTenancy';
const ALLOW_PREFIX = 'ALLOW group <CustomerCreatedKentikGroup>';

const generatePolicyStatements = (crossTenancy = false, statements = []) => {
  if (crossTenancy) {
    return statements.map((statement) => `${ADMIT_PREFIX} ${statement}`);
  }

  return statements.map((statement) => `${ALLOW_PREFIX} ${statement}`);
};

export function generatePolicy(options = { crossTenancy: false, includeFlowLogs: false, includeMetrics: false }) {
  const { crossTenancy = false, includeFlowLogs = false, includeMetrics = false } = options;

  const result = [];

  if (crossTenancy) {
    result.push(...KENTIK_POLICY_DEFINITIONS);
  }

  result.push(...generatePolicyStatements(crossTenancy, METADATA_POLICY_DEFINITIONS));

  if (includeFlowLogs) {
    result.push(...generatePolicyStatements(crossTenancy, FLOWS_POLICY_DEFINITIONS));
  }

  if (includeMetrics) {
    result.push(...generatePolicyStatements(crossTenancy, METRICS_POLICY_DEFINITIONS));
  }
  return result;
}
